import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateParentAlertsMutation = graphql.persisted(
  "UpdateParentAlerts",
  graphql(`
    mutation UpdateParentAlerts($input: UpdateParentAlertsInput!) {
      updateParentAlerts(input: $input) {
        school {
          id
          parentAlertsSetting {
            enabled
            invoiceEmails
            invoiceEmailsSince
            invoiceOverdue
            invoiceDue
            enrollmentAction
            missingWork
            lowGrade
            showGradeColors
            lowGradeFloorLetter
            lowGradeFloorPercentage
          }
        }
        userErrors { message path }
      }
    }
  `)
);

export { UpdateParentAlertsMutation };

export function useUpdateParentAlerts() {
  return useMutation(UpdateParentAlertsMutation);
}
